import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { InputFileUpload, Text } from "@pentabd/ui";

import {
  GENERAL_INFO,
  GeneralInfoFormDataType,
} from "@validations/HRM/employee/generalInfoValidation";

const Documents = () => {
  const { t } = useTranslation();

  const {
    register,
    formState: { errors },
  } = useFormContext<GeneralInfoFormDataType>();

  return (
    <div className="d-flex flex-column gap-8">
      <div className="row">
        <div className="col-3">
          <Text weight="semibold" size="sm" color="title">
            {t("EMPLOYEE.GENERAL_INFO.FORM.UPLOAD_CERTIFICATE.LABEL")}
          </Text>
        </div>
        <div className="col-9 col-lg-7">
          <InputFileUpload
            id="certificate-update"
            {...register(GENERAL_INFO.UPLOAD_CERTIFICATE)}
            error={errors as any}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-3">
          <Text weight="semibold" size="sm" color="title">
            {t("EMPLOYEE.GENERAL_INFO.FORM.SUPPORTING_DOCUMENTS.LABEL")}
          </Text>
        </div>
        <div className="col-9 col-lg-7">
          <InputFileUpload
            id="supporting-document"
            {...register(GENERAL_INFO.SUPPORTING_DOCUMENTS)}
            error={errors as any}
          />
        </div>
      </div>
    </div>
  );
};
export default Documents;
